import type { CloneFormEpicApi } from 'epic/newDynamicForm/cloneDynamicFormEpic';
import type { CloseDynamicFormEpicApi } from 'epic/newDynamicForm/closeDynamicFormEpic';
import type { DynamicFormEnrichmentRequestedEpicApi } from 'epic/newDynamicForm/enrichment-requested';
import type { FetchDefaultFormEpicApi } from 'epic/newDynamicForm/fetchDefaultDynamicFormEpic';
import type { FetchFormWhenRepricingQuoteEpicApi } from 'epic/newDynamicForm/fetchDynamicFormWhenQuoteRepriceEpic';
import type {
  DynamicProductCodesRequest,
  DynamicRequestProductCodesEpicApi,
} from 'epic/newDynamicForm/requestProductCodesEpic';
import type { DynamicFormResult } from 'models/forms/DynamicFormResult';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { ignoreElements, map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export interface InitFormRequest {
  tabId: string;
  tradeDate: string;
  instrumentName?: string;
  instrumentContractName?: string;
  wrapper?: string;
  isPrivateMode?: boolean;
  currency?: string;
  selectedOnBehalfClient?: ISalesCounterpart;
  xMargin?: number;
}

type DynamicFormApi = FetchDefaultFormEpicApi &
  DynamicFormEnrichmentRequestedEpicApi &
  CloneFormEpicApi &
  CloseDynamicFormEpicApi &
  FetchFormWhenRepricingQuoteEpicApi &
  DynamicRequestProductCodesEpicApi;

export function dynamicFormApiConnector(httpClient: IHttpClient): DynamicFormApi {
  const dynamicFormApi = 'api/v1/dynamic-form/';

  return {
    initForm(request) {
      const url = `${dynamicFormApi}${'init-product'}`;
      return httpClient.post<DynamicFormResult>({ url, body: request }).pipe(map(({ payload }) => payload));
    },
    enrichForm(request) {
      return httpClient
        .post<DynamicFormResult>({ url: dynamicFormApi + `modify`, body: request })
        .pipe(map(({ payload }) => payload));
    },
    cloneForm(request) {
      return httpClient
        .post<DynamicFormResult>({ url: dynamicFormApi + 'clone', body: request })
        .pipe(map(({ payload }) => payload));
    },
    closeSession(id: string, productType: string, productSubtype: string) {
      return httpClient
        .delete<boolean>({
          url: dynamicFormApi + `session/${id}?${new URLSearchParams({ productType, productSubtype }).toString()}`,
        })
        .pipe(ignoreElements());
    },
    getDynamicFormByIdType(request) {
      const url = dynamicFormApi + 'reload';
      return httpClient.post<DynamicFormResult>({ url, body: request }).pipe(map(({ payload }) => payload));
    },
    generateProductCodes(request: DynamicProductCodesRequest) {
      return httpClient
        .post<DynamicFormResult>({ url: dynamicFormApi + 'compute-codes', body: request })
        .pipe(map(({ payload }) => payload));
    },
  };
}
